import request from "./request";
import * as qiniu from "qiniu-js";
import {store} from "../index";


export async function upload(files, type) {
    const results = []
    for (const file of files) {
        results.push(await uploadFile(file, type))
    }
    return results
}

function uploadFile(file, type) {
    const {id, company_id} = store.getState().auth.userInfo
    const key = `${company_id}/${file.key}`
    return getToken(type, key).then(({data}) => {
        return new Promise((resolve, reject) => {
            const observable = qiniu.upload(file.file, key, data.data, {
                params: {
                    ...file.putExtra.params,
                    'x:userId': id,
                    'x:companyId': company_id
                }
            })
            observable.subscribe({
                complete: res => {
                    resolve(res)
                },
                error: error => {
                    reject(error)
                }
            })
        })
    })
}

async function getToken(type, key) {
    return request({
        url: '/api/qiniu/token',
        params: {
            type: type,
            key: key
        }
    })
}
